<svelte:body on:item={put_item} />
<script>
    // Форк «Шторы плиссе» для склада 53. Имя изделия в заказе остаётся «Шторы плиссе».
    // Сетка и имена полей — как в CalcRimskie.svelte.
    import _ from 'lodash';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    const cvetaKarniza = options.color || {
        'Белый RAL 9016': 'Белый RAL 9016',
        'Коричневый RAL 8017': 'Коричневый RAL 8017',
        'Антрацит RAL 7016': 'Антрацит RAL 7016',
        'Серый RAL 7040': 'Серый RAL 7040',
        'Черный RAL 9005': 'Черный RAL 9005',
        'спец.покраска': 'спец.покраска',
    };

    const vidyShtory = options.shtorytypes || {
        'PLAIN': 'PLAIN',
        'ELEGANCE': 'ELEGANCE',
        'MOON': 'MOON',
        'SHINE': 'SHINE',
        'CANVAS': 'CANVAS',
        'STRiPE': 'STRiPE',
        'MESH': 'MESH',
        'CLASS BAMBOO': 'CLASS BAMBOO',
        'DIMOUT': 'DIMOUT',
        'LINEN': 'LINEN',
        'WIND': 'WIND',
        'VIP BLACKOUT': 'VIP BLACKOUT',
        'HONEYCOMB': 'HONEYCOMB',
        'BLACKOUT': 'BLACKOUT',
    };

    const nomer = (count, width) => Array.from({length: count}, (_, i) => String(i + 1).padStart(width, '0'));

    const cvetaPoTkani = options.shtorycolors || {
        'PLAIN': nomer(16, 2),
        'CANVAS': nomer(8, 2),
        'LINEN': nomer(4, 2),
        'ELEGANCE': nomer(5, 2),
        'MESH': nomer(3, 2),
        'STRiPE': nomer(3, 2),
        'SHINE': nomer(6, 2),
        'MOON': nomer(6, 2),
        'WIND': nomer(5, 2),
        'VIP BLACKOUT': nomer(4, 2),
        'CLASS BAMBOO': nomer(4, 2),
        'BLACKOUT': nomer(6, 3),
        'DIMOUT': nomer(4, 3),
        'HONEYCOMB': [
            'WS001 белый',
            'WS002 кремовый',
            'WS003 светло-серый',
            'WS004 коричневый',
            'WS005 антрацит',
            'WS006 чёрный',
            'WS007 тёмно-серый',
        ],
    };

    const cvetaAksessuarov = options.komplektcolor || [
        'Белый RAL 9016',
        'Бежевый RAL 1013',
        'Черный RAL 9005',
        'Серый RAL 7040',
    ];

    const ruchki = ['Нет', '50', '75', '100', '150'];

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let size = item.title.split(' ')[2].split(',')[0];
            width.set(size.split('x')[0]);
            height.set(size.split('x')[1]);

            let title = item.title.split(',');

            const cvetaKarnizaPoDline = Object.keys(cvetaKarniza).sort((a, b) => b.length - a.length);
            for (const key of cvetaKarnizaPoDline) {
                if (title[1] && title[1].toLowerCase().includes(key.toLowerCase())) {
                    cvetKarniza = cvetaKarniza[key];
                    break;
                }
            }
            if (title[1] && title[1].toLowerCase().includes('черный') && !title[1].toLowerCase().includes('ral 9005')) {
                cvetKarniza = 'Черный RAL 9005';
            }

            let vid = title[2].trim();
            if (vidyShtory[vid]) {
                vidShtory = vid;
            }

            const cvetaEtoyTkani = (cvetaPoTkani[vidShtory] || []).slice().sort((a, b) => b.length - a.length);
            for (const element of cvetaEtoyTkani) {
                if (title[3] && title[3].includes(element)) {
                    cvetShtory = element;
                    break;
                }
            }

            for (var element of cvetaAksessuarov) {
                if (title[4].includes(element)) {
                    cvetAksessuarov = element;
                }
            }

            if (item.title.includes('ручка нет')) {
                ruchka = 'Нет';
            } else {
                for (const len of ['150', '100', '75', '50']) {
                    if (item.title.includes('ручка ' + len + ' см')) {
                        ruchka = len;
                    }
                }
            }
            skotch = item.title.includes('монтажный профиль на скотч') ? 'Да' : 'Нет';

            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch();
            change();
        }
    };

    const fetch = async () => {
        let result = await network.fetch_data('Шторы плиссе 53', '', '');
        let ind = await network.fetch_ind('Шторы плиссе 53');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options: ind,
            result,
        }
    }

    let
        width = parameter('width', '240'),
        height = parameter('height', '400'),
        cvetKarniza = 'Белый RAL 9016',
        vidShtory = 'PLAIN',
        cvetShtory = '01',
        cvetAksessuarov = 'Белый RAL 9016',
        ruchka = 'Нет',
        skotch = 'Нет',

        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch();

    $: cvetaShtory = cvetaPoTkani[vidShtory] || [];
    $: if (cvetaShtory.length && cvetaShtory.indexOf(cvetShtory) === -1) {
        cvetShtory = cvetaShtory[0];
    }
    $: cvetKartinka = '/img/plisse/53/'
        + String(vidShtory).toLowerCase().replace(/\s+/g, '-')
        + '/'
        + String(cvetShtory).split(' ')[0].toLowerCase()
        + '.jpg';
    let cvetNet = '';

    $: cvetKarniza, vidShtory, cvetShtory, cvetAksessuarov,
        ruchka, skotch,
        $width, $height, $count, $comment,
        change();

    const minWidth = options.min && options.min.width != null ? options.min.width : 0;
    const maxWidth = options.max && options.max.width != null ? options.max.width : 1200;
    const minHeight = options.min && options.min.height != null ? options.min.height : 0;
    const maxHeight = options.max && options.max.height != null ? options.max.height : 2500;

    $: shirinaVne = $width < minWidth || $width > maxWidth;
    $: vysotaVne = $height < minHeight || $height > maxHeight;

    const isPriceRow = (item) => String(item.nameZvena || '').toLowerCase().includes('прайс');

    const rangeHolds = (range, value) => {
        const parts = String(range || '').split('-');
        if (parts.length !== 2) {
            return false;
        }
        const from = parseFloat(parts[0]);
        const to = parseFloat(parts[1]);
        // Сплошные диапазоны 0-40, 40-50, 50-60. Точная граница принадлежит строке, которая на ней заканчивается.
        if (from === 0) {
            return value >= from && value <= to;
        }
        return value > from && value <= to;
    };

    const artikulHasFabric = (artikul, fabric) =>
        String(artikul || '').split('+').map((part) => part.trim().toLowerCase()).includes(String(fabric || '').toLowerCase());

    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;

        const ruchkaText = ruchka === 'Нет' ? 'ручка нет' : 'ручка ' + ruchka + ' см';

        let opisanie = [
            $width + 'x' + $height, ', ',
            cvetKarniza, ' - цвет карниза, ', vidShtory, ', ', cvetShtory, ' - шторка, ', cvetAksessuarov, ' - аксессуары, ', ruchkaText,
            skotch === 'Да' ? ', монтажный профиль на скотч' : ''
        ].join('');

        let result = {
            type: 'шторы-плиссе',
            name: 'Шторы плиссе',
            subname: opisanie,
            title: ['Шторы плиссе', ' ', opisanie].join(''),
            params: {
                ind1: [cvetAksessuarov, ' - аксессуары, ', ruchkaText, skotch === 'Да' ? ', монтажный профиль на скотч' : ''].join(''),
                ind2: cvetKarniza,
                ind3: [vidShtory, ', ', cvetShtory].join(''),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 172
        };

        const widthCm = w / 10;
        const heightCm = h / 10;
        const rows = Array.isArray(data && data.result) ? data.result : [];
        const priceRow = rows.find((item) =>
            isPriceRow(item) &&
            artikulHasFabric(item.artikul, vidShtory) &&
            rangeHolds(item.ind4, widthCm) &&
            rangeHolds(item.ind5, heightCm)
        );

        _.forEach(rows, function (item) {
            if (isPriceRow(item)) {
                return;
            }

            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;


            if (name === 'карниз ' + cvetKarniza.toLowerCase()) {
                kolvo = ((w - 5) * 2 / 1000).toFixed(3);
            }

            if (name === vidShtory.toLowerCase()) {
                kolvo = ((w - 2) * h / 2.2 * 0.028 / 10000).toFixed(3);
            }

            if (name.includes('вставка')) {
                kolvo = ((w - 4) * 2 / 1000).toFixed(3);
            }

            if (name.includes('комплектующие') && name.includes(cvetAksessuarov.toLowerCase())) {
                kolvo = (1).toFixed(3);
            }

            if (ruchka !== 'Нет' && name.includes('ручка управления ' + ruchka + ' см')) {
                kolvo = (1).toFixed(3);
            }

            if (skotch === 'Да' && name.includes('монтажный профиль на скотч')) {
                kolvo = ((w - 5) * 2 / 1000).toFixed(3);
            }

            if (name.includes('заклепки')) {
                kolvo = (8).toFixed(3);
            }

            if (name.includes('работа')) {
                kolvo = 1;
            }

            if (kolvo) {
                price['rozn'] = 0;
                price['opt'] = 0;
                price['sebest'] = name.includes('монтажный профиль на скотч')
                    ? fixprecision(Number(item.sebestomost) * kolvo)
                    : 0;

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        if (priceRow) {
            const spis = +priceRow.procentSpisania || 0;
            const tape = skotch === 'Да'
                ? rows.find((item) => String(item.name || '').toLowerCase().includes('монтажный профиль на скотч'))
                : null;
            const withTape = (value, percent) => fixprecision((1 + spis / 100) * Number(value || 0) * (1 + (Number(percent) || 0) / 100));
            const gridSebest = fixprecision((1 + spis / 100) * Number(priceRow.sebestomost || 0));
            const tapeSebest = tape && result.materials[tape.name] ? Number(result.materials[tape.name].price.sebest) || 0 : 0;
            const tariff = {
                rozn: withTape(priceRow.price, tape ? tape.price : 0),
                opt: withTape(priceRow.opt_price, tape ? tape.opt_price : 0),
                optovaya: withTape(priceRow.price3, tape ? tape.price3 : 0),
                sebest: gridSebest,
            };

            result.materials[priceRow.name] = {
                order: +priceRow.poryadok || 0,
                id: priceRow.idTovar,
                spis,
                type: priceRow.edIzmer,
                oprice: {
                    rozn: (+priceRow.price).toFixed(2),
                    opt: (+priceRow.opt_price).toFixed(2),
                    sebest: (+priceRow.sebestomost).toFixed(2),
                },
                price: {
                    rozn: tariff.rozn,
                    opt: tariff.opt,
                    sebest: tariff.sebest,
                },
                quantity,
                count: (1).toFixed(3)
            };

            result.price.rozn = tariff.rozn.toFixed(2);
            result.price.opt = tariff.opt.toFixed(2);
            result.price.optovaya = tariff.optovaya.toFixed(2);
            result.price.sebest = (gridSebest + tapeSebest).toFixed(2);
        } else {
            result.price.rozn = '0.00';
            result.price.opt = '0.00';
            result.price.sebest = '0.00';
        }

        dispatch('item', result);
    }, 250);

    change();
</script>

<style>
    .parent {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: auto;
        grid-column-gap: 5px;
        grid-row-gap: 0px;
        grid-template-areas:
            "cvetKarniza vidShtory"
            "width height"
            "cvetShtory cvetAksessuarov"
            "ruchka skotch"
            "count count"
            "comment comment"
            "pic pic";
    }

    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: repeat(3, 1fr);
            grid-template-areas:
                "pic cvetKarniza vidShtory"
                "pic width height"
                "pic cvetShtory cvetAksessuarov"
                "pic ruchka skotch"
                "pic count count"
                "comment comment comment";
        }
    }

    .pic { grid-area: pic; }
    .cvetKarniza { grid-area: cvetKarniza; }
    .cvet-obrazec {
        max-width: calc(100% - 2rem);
        max-height: 72px;
        margin: 0 auto 0.75rem;
        object-fit: contain;
    }
    .vidShtory { grid-area: vidShtory; }
    .width { grid-area: width; }
    .height { grid-area: height; }
    .cvetShtory { grid-area: cvetShtory; }
    .cvetAksessuarov { grid-area: cvetAksessuarov; }
    .ruchka { grid-area: ruchka; }
    .skotch { grid-area: skotch; }
    .count { grid-area: count; }
    .comment { grid-area: comment; }

    .warn {
        grid-column: 1 / -1;
    }
</style>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then}
    <div class="card-body">
        {#if shirinaVne || vysotaVne}
            <div class="warn">
                <span class="badge-danger text-white small rounded-2 text-center text-uppercase">Размер вне диапазона прайса</span>
            </div>
        {/if}

        <div class="parent">
            <div class="pic text-center">
                <img style="max-height: 300px" class="img-fluid p-3" src="/img/plisse/PlisseShtory.jpeg" alt="Шторы плиссе"/>
                <img class="cvet-obrazec" src={cvetKartinka} alt={cvetShtory}
                     style="display: {cvetNet === cvetKartinka ? 'none' : 'block'}"
                     on:error={() => cvetNet = cvetKartinka}/>
            </div>

            <div class="cvetKarniza">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="cvetKarniza">Цвет карниза</label>
                        <select id="cvetKarniza" class="form-control form-select" bind:value={cvetKarniza}>
                            {#each Object.keys(cvetaKarniza) as value (value)}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="vidShtory">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="vidShtory">Вид шторы</label>
                        <select id="vidShtory" class="form-control form-select" bind:value={vidShtory}>
                            {#each Object.entries(vidyShtory) as [value, name] (value)}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="width">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="width">Ширина {minWidth}–{maxWidth} мм</label>
                        <input id="width" type="number"
                               class="form-control text-center {shirinaVne ? 'text-danger' : ''}"
                               step="10"
                               min="{minWidth}"
                               max="{maxWidth}"
                               bind:value={$width}>
                    </div>
                </div>
            </div>

            <div class="height">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="height">Высота {minHeight}–{maxHeight} мм</label>
                        <input id="height" type="number"
                               class="form-control text-center {vysotaVne ? 'text-danger' : ''}"
                               step="10"
                               min="{minHeight}"
                               max="{maxHeight}"
                               bind:value={$height}>
                    </div>
                </div>
            </div>

            <div class="cvetShtory">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="cvetShtory">Цвет шторы</label>
                        <select id="cvetShtory" class="form-control form-select" bind:value={cvetShtory}>
                            {#each cvetaShtory as value (value)}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="cvetAksessuarov">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="cvetAksessuarov">Цвет аксессуаров</label>
                        <select id="cvetAksessuarov" class="form-control form-select" bind:value={cvetAksessuarov}>
                            {#each cvetaAksessuarov as value (value)}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="ruchka">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="ruchka">Ручка управления</label>
                        <select id="ruchka" class="form-control form-select" bind:value={ruchka}>
                            {#each ruchki as value (value)}
                                <option value="{value}">{value === 'Нет' ? 'Нет' : value + ' см'}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="skotch">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="skotch">Монтаж на скотч</label>
                        <select id="skotch" class="form-control form-select" bind:value={skotch}>
                            <option value="Нет">Нет</option>
                            <option value="Да">Да, без сверления</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="count">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="count">Количество</label>
                        <input id="count" type="number" class="form-control" min="1" bind:value={$count}>
                    </div>
                </div>
            </div>

            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="comment">Примечание</label>
                        <textarea id="comment" class="form-control" bind:value={$comment}></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}
